/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TMessagesReadModel,
  IMessagesReadRequest,
  IMappers,
  IMessagesReadResponse,
  IMessagesReadResponseError,
  TMessagesReadResponse,
} from './types';

const defaultConfig: TMessagesReadModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/messages/read/',
  hostType: 'api',
} as TMessagesReadModel;

function createMessagesReadModel(parameters: IMessagesReadRequest): TMessagesReadModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IMessagesReadOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IMessagesReadRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchMessagesRead<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IMessagesReadOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TMessagesReadResponse> {
  const { response, statusCode } = await httpApi.fetch(createMessagesReadModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMessagesReadResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IMessagesReadResponseError);
    }
  }

  return { response, statusCode } as TMessagesReadResponse;
}

export { defaultConfig, createMessagesReadModel, fetchMessagesRead };
